<app-navbar-insights *ngIf='showHeader' class='fixed-top'></app-navbar-insights>
<div class='container-fluid insights-container' [ngClass]="{ 'overflow-y-clip': shouldClipOverflowY }">
  <div class='row h-100'>
    <div class='col-12 col-md-12 col-lg-12 p-0'>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

